import { useRouter } from 'next/router';
import React, { createContext, useState, useEffect, useContext } from 'react';
import { AMPLITUDE_EVENTS } from '../constants';
import { isBrowser } from '../utils/isBrowser';
import useAuth from './AuthContext';

interface ContextData {
  amplitude: any;
}

export const AmplitudeContext = createContext<ContextData>({
  amplitude: null,
});

export const AmplitudeProvider = ({ children }) => {
  const { loggedInUser } = useAuth();
  const router = useRouter();
  const [instance, setInstance] = useState(null);

  const getPageViewData = () => {
    return (
      {
        url: window.location.href,
        referrer: document.referrer,
        path: window.location.pathname,
        hostname: window.location.hostname
      }
    )
  }

  const handleRouteChange = () => {
    if (isBrowser() && instance) {
      instance.logEvent(AMPLITUDE_EVENTS.PAGE_VIEW, getPageViewData());
    }
  };

  const initAmplitude = () => {
    if (isBrowser()) {
      let amplitude = require('amplitude-js');
      amplitude.getInstance().init(process.env.NEXT_PUBLIC_AMPLITUDE_KEY);
      setInstance(amplitude);
      amplitude.getInstance().logEvent(AMPLITUDE_EVENTS.PAGE_VIEW, getPageViewData());
    }
  };


  useEffect(() => {
    initAmplitude();
  }, []);

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [instance]);

  useEffect(() => {
    if (loggedInUser && instance) {
      instance.setUserId(loggedInUser.username);
      let identify = new instance.Identify();
      identify.setOnce('codealo_id', loggedInUser.id);
      identify.setOnce('first', loggedInUser.first);
      identify.setOnce('last', loggedInUser.last);
      identify.setOnce('email', loggedInUser.email);
      instance.identify(identify);
    }
  }, [loggedInUser, instance]);

  return (
    <AmplitudeContext.Provider value={{ amplitude: instance }}>
      {children}
    </AmplitudeContext.Provider>
  )
}


export default function useAmplitude() {
  const context = useContext(AmplitudeContext)
  return context
};
